import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "icon_table_sound_on",
  xmlns: "http://www.w3.org/2000/svg",
  width: "17.006",
  height: "15.168",
  viewBox: "0 0 17.006 15.168"
}
const _hoisted_2 = ["fill"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("path", {
      id: "Path_557",
      "data-name": "Path 557",
      d: "M-2271.031-3144.54l-2.941-2.753v-9.361l2.941-2.2c1.281-.9,2.1.132,2.1,1.652v11.013c0,1.126-.528,2-1.264,2A1.343,1.343,0,0,1-2271.031-3144.54Zm6.322-1.035a10.232,10.232,0,0,0,1.955-6.009,9.478,9.478,0,0,0-1.948-6.468l1.511-1.31a11.32,11.32,0,0,1,2.436,7.843,12.115,12.115,0,0,1-2.429,7.238Zm-3.183-2.208a6.8,6.8,0,0,0,1.383-4.117,6.814,6.814,0,0,0-1.32-4.033l1.616-1.177a8.8,8.8,0,0,1,1.7,5.21,8.789,8.789,0,0,1-1.785,5.318Zm-7.76.49c-1.16,0-2.1-1.233-2.1-2.753v-3.855c0-1.52.941-2.753,2.1-2.753h1.26v9.361Z",
      transform: "translate(2277.754 3159.361)",
      fill: _ctx.isOn ? 'white' : 'red'
    }, null, 8, _hoisted_2)
  ]))
}